enum CampaignUrlParamKey {
  ScrollToContent = "scrollToContent",
  Tab = "tab",
}

export default CampaignUrlParamKey;
